/*
 * Copyright (c) Nexign, JSC, 2022-2024.
 */
/**
 *
 *
 * @author Julia Ignatieva
 * @author Ilya Baranchikov
 * @version 1.28.0
 * @since 1.19.0
 */

import { pageApi } from '@/main/api/page.api';

import { IInquiryState } from './inquiryStateTypes';

export const inquiryStateApi = pageApi.injectEndpoints({
    endpoints: (builder) => ({
        getInquiryState: builder.query<IInquiryState, void>({
            query: () => 'inquiry/state',
        }),
        getOtherInquiryState: builder.query<IInquiryState, void>({
            query: () => 'other-inquiry/state',
        }),
        postInquirySync: builder.query<void, void>({
            query: () => ({
                url: 'inquiry/sync',
                method: 'POST',
            }),
        }),
        postOtherInquirySync: builder.query<void, void>({
            query: () => ({
                url: 'other-inquiry/sync',
                method: 'POST',
            }),
        }),
    }),
});

export const {
    useLazyGetInquiryStateQuery,
    useLazyGetOtherInquiryStateQuery,
    useLazyPostInquirySyncQuery,
    useLazyPostOtherInquirySyncQuery,
} = inquiryStateApi;
